import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getWebstoryById } from "service/api";
import { FiPause, FiPlay, FiSend } from "react-icons/fi";
import { FiX } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";


const StoriesView = () => {
  const [webstory, setWebstory] = useState(null);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchWebstory = async () => {
      try {
        const response = await getWebstoryById(id);
        if (response?.data?.webstory) {
          setWebstory(response.data.webstory);
        } else {
          setError("Webstory not found.");
        }
      } catch (err) {
        setError("Error fetching webstory details.");
        console.error(err);
      }
    };
    fetchWebstory();
  }, [id]);

  useEffect(() => {
    if (!webstory || !isPlaying) return;
    setProgress(0);
    timerRef.current = setInterval(() => setProgress((prev) => prev + 10), 300);
    return () => clearInterval(timerRef.current);
  }, [currentIndex, webstory, isPlaying]);

  useEffect(() => {
    if (progress >= 100) nextSlide();
  }, [progress]);

  const nextSlide = () => setCurrentIndex((prev) => (prev < webstory.details.length - 1 ? prev + 1 : 0));
  const prevSlide = () => setCurrentIndex((prev) => (prev === 0 ? webstory.details.length - 1 : prev - 1));

  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!webstory) return <p>Loading...</p>;

  const whatsappNumber = "+919586363303";
  // const currentSlide = webstory.details[currentIndex];
  // const imageUrl = `https://aiinrealestate.in/api${currentSlide.img}`;

  // const whatsappMessage = `Check out this story:\n\nDescription: ${currentSlide.description}\nImage: ${imageUrl}\n\nLink: ${window.location.href}`; const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const currentSlide = webstory.details[currentIndex];
  const imageUrl = `https://aiinrealestate.in/api${currentSlide.img}`;
  const pageUrl = window.location.href;

  const whatsappMessage =
    `🖼️ *Check out this story!*\n\n` +
    `📄 *Description:* ${currentSlide.description}\n\n` +
    `🖼️ *Image:* ${imageUrl}\n` +
    `🔗 *Link:* ${pageUrl}`;

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;


  // const whatsappMessage = `Can you provide more details on this story?: ${window.location.href}`;
  // const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  const whatsappButtonStyle = {
    position: "absolute", bottom: "20px", right: "20px",
    backgroundColor: "#25D366", color: "white",
    border: "none", padding: "8px", borderRadius: "50%",
    cursor: "pointer", display: "flex",
    alignItems: "center", justifyContent: "center",
  };

  return (

    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <div style={{
        position: "relative",
        width: "100%",
        maxWidth: "800px",
        height: "100%",
        overflow: "hidden",
      }}>
        {/* Image */}
        {/* <img src={`http://localhost:5000${webstory.details[currentIndex].img}`} alt="Story" style={{ */}
        <img src={`https://aiinrealestate.in/api${webstory.details[currentIndex].img}`} alt="Story" style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          transform: "scale(1)", // Initial state
          transition: "transform 5s ease-in-out", // Smooth zoom effec
          animation: "none" // Prevents animation issues in some browsers
        }}
          onLoad={(e) => e.target.style.transform = "scale(1.1)"}
        />
        {/* Progress Indicators */}
        <div style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          right: "10px",
          display: "flex",
          gap: "5px",
        }}>
          {webstory.details.map((_, index) => (
            <div key={index} style={{
              flex: 1,
              height: "4px",
              borderRadius: "5px", // Rounded edges for a sleek look
              backgroundColor: "rgba(255, 255, 255, 0.3)", // Default inactive color
              overflow: "hidden", // Ensures smooth transition inside
              position: "relative",
            }}>
              {/* Animated progress fill */}
              <div style={{
                width: currentIndex === index ? `${progress}%` : (index < currentIndex ? "100%" : "0%"),
                height: "100%",
                backgroundColor: "white", // Active progress color
                transition: "width 0.3s linear",
              }} />
            </div>
          ))}
        </div>

        {/* Description on the Image */}
        <div style={{
          position: "absolute",
          bottom: "65px", // More space from the bottom
          left: "50%",
          transform: "translateX(-50%)",
          width: "90%",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Darker semi-transparent background
          color: "white",
          padding: "12px 16px",
          borderRadius: "10px",
          textAlign: "center",
          fontSize: "22px", // Larger font size
          fontFamily: "'Poppins', sans-serif", // Stylish & professional font
          fontWeight: "600", // Bolder text
          letterSpacing: "1px", // Slight spacing for a cleaner look
        }}>
          {webstory.details[currentIndex].description}
        </div>

        {/* Read More Button (Only shown if webstory.url exists) */}

        {/* Read More Button (Only shown if webstory.url exists) */}
        {webstory.details[currentIndex].urls?.trim().startsWith("http") && (
          <a href={webstory.details[currentIndex].urls}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              position: "absolute",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "linear-gradient(90deg, #ff7e5f, #feb47b)",
              color: "white",
              padding: "8px 16px",
              borderRadius: "30px",
              fontSize: "15px",
              fontWeight: "600",
              textDecoration: "none",
              fontFamily: "'Poppins', sans-serif",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
              transition: "0.3s",
              textAlign: "center",
              display: "inline-block",
            }}
            onMouseOver={(e) =>
              (e.target.style.background = "linear-gradient(90deg, #feb47b, #ff7e5f)")
            }
            onMouseOut={(e) =>
              (e.target.style.background = "linear-gradient(90deg, #ff7e5f, #feb47b)")
            }
          >
            Read More
          </a>
        )}


        {/* Top-right Buttons (Close & Pause/Play) */}
        <div style={{
          position: "absolute",
          top: "15px",
          right: "15px",
          display: "flex",
          gap: "10px",
        }}>
          {/* Pause/Play Button */}
          <button
            onClick={() => setIsPlaying(!isPlaying)}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.0)",
              zIndex: 9999,
              color: "white",
              border: "none",
              padding: "10px",
              borderRadius: "50%",
              fontSize: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "0.3s",
            }}
            title={isPlaying ? "Pause" : "Play"}
          >
            {isPlaying ? <FiPause size={24} /> : <FiPlay size={24} />}
          </button>

          {/* Close Button */}
          <button
            onClick={() => navigate(-1)} // Navigate back on click
            style={{
              // position: "absolute",
              // top: "0px",
              // right: "40px",
              backgroundColor: "rgba(0, 0, 0, 0.0)",
              zIndex: 9999,
              color: "white",
              border: "none",
              padding: "10px",
              borderRadius: "50%", // Circle button
              fontSize: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "0.3s",
            }}
            title="Close Story"
          >
            <FiX size={24} /> {/* Stylish close icon */}
          </button>
        </div>
        {/* Navigation Buttons */}
        <button onClick={prevSlide} style={{ position: "absolute", left: "20px", top: "50%", transform: "translateY(-50%)", backgroundColor: "transparent", color: "white", border: "none", fontSize: "24px", cursor: "pointer" }}>❮</button>
        <button onClick={nextSlide} style={{ position: "absolute", right: "20px", top: "50%", transform: "translateY(-50%)", backgroundColor: "transparent", color: "white", border: "none", fontSize: "24px", cursor: "pointer" }}>❯</button>

        {/* Share Button */}
        <button onClick={() => navigator.share({ title: "Story", url: window.location.href })} style={{
          position: "absolute", top: "16px", right: "130px",
          backgroundColor: "rgba(0, 0, 0, 0.0)",
          zIndex: 9999, color: "white",
          border: "none", padding: "10px", borderRadius: "50%",
          fontSize: "12px", cursor: "pointer",
        }} title="Share Story">
          <FiSend size={24} />
        </button>

        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" style={whatsappButtonStyle} title="Share on WhatsApp">
          <FaWhatsapp size={28} />
        </a>
      </div>
    </div>
  );
};
export default StoriesView;



